import React, {Component} from 'react';
import './Dialog.css';

const getButtonHandler = (item, props) =>
	props['on' + item.substring(0, 1).toUpperCase() + item.substring(1).replace(/ /g, '')];

class Dialog extends Component {
	handleKey = e => {
		if (e.key === 'Escape') {
			this.props.onCancel();
		} else if (e.key === 'Enter' && this.props.submitOnEnter) {
			if (this.props.onSave && (!this.props.disabled || !this.props.disabled['save'])) {
				this.props.onSave();
			} else if (this.props.buttons && this.props.buttons.length > 1) {
				// assumes the positive action is always stored as the 2nd item or uses the emphasis
				if (
					!this.props.disabled ||
					(this.props.disabled &&
						!this.props.disabled[this.props.emphasis || this.props.buttons[1]])
				) {
					getButtonHandler(this.props.emphasis || this.props.buttons[1], this.props)();
				}
			}
		}
	};

	componentDidMount() {
		this.dialogEl.focus(); // auto draw focus when mounted
		document.addEventListener('keydown', this.handleKey, false);
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKey, false);
	}

	render() {
		const {
			className,
			emphasis = 'save',
			title,
			disabled = {},
			buttons = ['cancel', 'save'],
			onSave,
			onCancel,
			onUpdate,
			children
		} = this.props;

		return (
			<dialog className={`Dialog ${className}`} open={true} ref={el => (this.dialogEl = el)}>
				<header>
					<h1>{title}</h1>
					<button onClick={onCancel}>
						<span className="icon icon-close" />
					</button>
				</header>
				<section className="Dialog-body">{children}</section>
				<footer>
					{buttons.map(item => (
						<button
							key={item}
							className={'Dialog-' + item + ' ' + (emphasis === item ? 'Dialog-emphasis' : '')}
							onClick={getButtonHandler(item, this.props)}
							disabled={disabled[item]}>
							{item.substring(0, 1).toUpperCase() + item.substring(1)}
						</button>
					))}
				</footer>
			</dialog>
		);
	}
}

Dialog.defaultProps = {
	submitOnEnter: true
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/widgets/Dialog.js